module.exports = __webpack_public_path__ + "static/media/pampa.c96b17a0.mp3";